// @flow
import * as React from 'react'
import type { Question } from 'types/question'
import ToggleField from 'ui/molecules/ToggleField'

type Props = {
  question: Question,
  onUpdateQuestionProps: (any) => void,
}

function BuilderSignatureEditProps({
  question,
  onUpdateQuestionProps,
}: Props): React.Node {
  const onToggleClientSignature = React.useCallback(() => {
    onUpdateQuestionProps({
      client_signature: Boolean(!question.client_signature),
    })
  }, [onUpdateQuestionProps, question.client_signature])

  return (
    <ToggleField
      horizontal
      primary
      label="Client Signature"
      onChange={onToggleClientSignature}
      value={Boolean(question.client_signature)}
    />
  )
}

export default BuilderSignatureEditProps
